
import Vue from 'vue'

type LoaderFunc = (offset: number, pageSize: number) => Promise<TransferItemData[]>

export default Vue.extend({
    props: {
        loader: Function as unknown as () => LoaderFunc,
        pageSize: { default: 10 },
        sym: String
    },
    data: () => {
        return {
            items: null as TransferItemData[] | null,
            error: null as Error | null,
            loading: false,
            offset: 0
        }
    },
    computed: {
        canNext(): boolean { return !!this.items && this.items.length === this.pageSize },
        canPrev(): boolean { return !!this.items && this.offset > 0 },
        range(): [number, number] | null {
            if (!this.loading && this.items && this.items.length > 0) {
                return [this.offset, this.offset + this.items.length]
            }
            return null
        }
    },
    methods: {
        nextPage() {
            this.offset += this.pageSize
            this.reload()
        },
        prevPage() {
            if (this.offset >= this.pageSize) {
                this.offset -= this.pageSize
                this.reload()
            }
        },
        async reload() {
            if (this.loading) {
                return
            }
            this.error = null
            this.loading = true
            this.items = null
            try {
                this.items = await this.loader(this.offset, this.pageSize)
            } catch (err) {
                this.error = err as Error
            } finally {
                this.loading = false
            }
        }
    },
    created() {
        this.reload()
    }
})
